// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ewkx","footer":"Form_footer__20S5J"};